var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 709,
    height: 266,
    viewBox: "0 0 709 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_1_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.427 264.173C83.125 264.173 65.5824 262.25 47.7995 258.406C30.0166 254.561 14.3965 248.913 0.939147 241.464L29.7763 178.743C40.5902 184.991 51.8848 189.677 63.6599 192.801C75.4351 195.685 86.6095 197.127 97.1831 197.127C106.796 197.127 114.726 195.444 120.974 192.08C127.222 188.716 130.346 183.789 130.346 177.301C130.346 173.696 129.264 170.572 127.102 167.929C124.939 165.045 121.094 162.882 115.567 161.441C110.28 159.999 102.47 159.278 92.1366 159.278H18.9624L31.5786 6.08045H199.195V70.2431H61.4972L104.392 33.8362L96.8227 131.522L53.9274 95.1152H112.683C137.675 95.1152 157.621 98.7198 172.52 105.929C187.66 113.138 198.594 122.871 205.322 135.127C212.291 147.142 215.776 160.6 215.776 175.499C215.776 190.398 211.691 204.696 203.52 218.394C195.59 231.851 183.094 242.906 166.032 251.557C149.21 259.968 127.342 264.173 100.427 264.173ZM345.145 264.173C322.796 264.173 302.971 259.006 285.668 248.673C268.606 238.34 255.149 223.32 245.296 203.615C235.684 183.91 230.878 160.119 230.878 132.243C230.878 104.367 235.684 80.5764 245.296 60.871C255.149 41.1656 268.606 26.1463 285.668 15.813C302.971 5.47969 322.796 0.313032 345.145 0.313032C367.494 0.313032 387.199 5.47969 404.261 15.813C421.564 26.1463 435.021 41.1656 444.633 60.871C454.486 80.5764 459.412 104.367 459.412 132.243C459.412 160.119 454.486 183.91 444.633 203.615C435.021 223.32 421.564 238.34 404.261 248.673C387.199 259.006 367.494 264.173 345.145 264.173ZM345.145 196.045C350.672 196.045 355.599 194.123 359.924 190.278C364.25 186.433 367.614 179.824 370.017 170.452C372.661 161.08 373.982 148.344 373.982 132.243C373.982 115.902 372.661 103.166 370.017 94.0338C367.614 84.6617 364.25 78.0532 359.924 74.2082C355.599 70.3633 350.672 68.4408 345.145 68.4408C339.618 68.4408 334.692 70.3633 330.366 74.2082C326.04 78.0532 322.556 84.6617 319.913 94.0338C317.509 103.166 316.308 115.902 316.308 132.243C316.308 148.344 317.509 161.08 319.913 170.452C322.556 179.824 326.04 186.433 330.366 190.278C334.692 194.123 339.618 196.045 345.145 196.045ZM592.834 264.173C570.485 264.173 550.66 259.006 533.357 248.673C516.295 238.34 502.838 223.32 492.985 203.615C483.373 183.91 478.567 160.119 478.567 132.243C478.567 104.367 483.373 80.5764 492.985 60.871C502.838 41.1656 516.295 26.1463 533.357 15.813C550.66 5.47969 570.485 0.313032 592.834 0.313032C615.183 0.313032 634.888 5.47969 651.95 15.813C669.252 26.1463 682.71 41.1656 692.322 60.871C702.175 80.5764 707.101 104.367 707.101 132.243C707.101 160.119 702.175 183.91 692.322 203.615C682.71 223.32 669.252 238.34 651.95 248.673C634.888 259.006 615.183 264.173 592.834 264.173ZM592.834 196.045C598.361 196.045 603.287 194.123 607.613 190.278C611.938 186.433 615.303 179.824 617.706 170.452C620.349 161.08 621.671 148.344 621.671 132.243C621.671 115.902 620.349 103.166 617.706 94.0338C615.303 84.6617 611.938 78.0532 607.613 74.2082C603.287 70.3633 598.361 68.4408 592.834 68.4408C587.307 68.4408 582.38 70.3633 578.055 74.2082C573.729 78.0532 570.245 84.6617 567.601 94.0338C565.198 103.166 563.997 115.902 563.997 132.243C563.997 148.344 565.198 161.08 567.601 170.452C570.245 179.824 573.729 186.433 578.055 190.278C582.38 194.123 587.307 196.045 592.834 196.045Z",
    fill: "#E5E5DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_1_1389",
    x: 0.00000488758,
    y: 0.00000160933,
    width: 708.04,
    height: 266.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.626095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.469572
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1389",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_1_1389"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.35863
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.56524
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_1_1389",
    result: "effect3_innerShadow_1_1389"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/serverError.58200e35ee16e36ec1cf98a710446b9e.svg";
export { ForwardRef as ReactComponent };